import React, { useContext } from 'react';
import SidebarItem from './components/SidebarItem';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { UserRoles } from 'types';
import style from './Sidebar.module.scss';

const Sidebar: React.FC = () => {
	const { setStyleGroup, styleData, selectedStyleGroup } =
		useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);
	const hasAdditionalSettingsAccess = useRoleAccess([
		UserRoles.SUPER_USER,
		UserRoles.RESTAURANT_MANAGER,
		UserRoles.TECHNICAL,
	]);

	return (
		<>
			{styleData?.mediaSettings[0]?.groups.length ? (
				<div className={style.container}>
					<SidebarItem
						onClick={() => setStyleGroup({ id: 'colorsID', key: 'colorsKey' })}
						isActive={selectedStyleGroup?.id === 'colorsID'}
						label="colors"
					/>
					{styleData.mediaSettings[0].groups.map((el) => (
						<SidebarItem
							onClick={() => setStyleGroup(el)}
							isActive={selectedStyleGroup?.id === el.id}
							label={el.key}
							key={el.id}
						/>
					))}
					{styleData.documentSettings.map((el) => (
						<SidebarItem
							onClick={() => setStyleGroup({ id: el.id, key: el.key ? el.key : '' })}
							isActive={selectedStyleGroup?.id === el.id}
							label={el.key ? el.key : ''}
							key={el.id}
						/>
					))}
					{hasAdditionalSettingsAccess && (
						<SidebarItem
							onClick={() =>
								setStyleGroup({ id: 'additionalSettingFileID', key: 'additional_setting_file' })
							}
							isActive={selectedStyleGroup?.id === 'additionalSettingFileID'}
							label="additional_setting_file"
						/>
					)}
				</div>
			) : null}
		</>
	);
};

export default Sidebar;
